export const defaultState = {
  currentUser: null,
  loading: false,
  error: null,
}
